import { render, staticRenderFns } from "./LockedEvent.vue?vue&type=template&id=3d57f2d2&scoped=true"
import script from "./LockedEvent.vue?vue&type=script&lang=js"
export * from "./LockedEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d57f2d2",
  null
  
)

export default component.exports